/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreferredLanguageDto } from '../../models/preferred-language-dto';

export interface GetPreferredLanguage$Params {
}

export function getPreferredLanguage(http: HttpClient, rootUrl: string, params?: GetPreferredLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<PreferredLanguageDto>> {
  const rb = new RequestBuilder(rootUrl, getPreferredLanguage.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PreferredLanguageDto>;
    })
  );
}

getPreferredLanguage.PATH = '/i18n/preferred-language';
